import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { useIsSuperAdmin } from "@/entities/me/hooks/use-is-super-admin";
import { SidebarInset, SidebarProvider } from "@/shared/ui/sidebar";
import { AdminSidebar } from "@/widgets/admin-sidebar";
import { GlobalSearchBar } from "@/widgets/global-search/ui/global-search-bar";
import { HubSpotProvider } from "@/features/hubspot-chat";
import { SuspenseAndErrorBoundary } from "@/shared/ui/suspense-and-error-boundary";
import { AppSkeleton } from "@/shared/ui/app-skeleton";
import { PageSkeleton } from "@/shared/ui/page-skeleton";

const AdminLayout = () => {
  const isSuperAdmin = useIsSuperAdmin();

  if (!isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    // Mirrors the app shell in $companySlug.tsx: a suspending admin page shows a
    // page skeleton inside the panel instead of blanking the whole card.
    <HubSpotProvider>
      <SuspenseAndErrorBoundary fallback={<AppSkeleton />}>
        {/* overflow-x-clip, not hidden: `hidden` would make this a scroll
            container and compute overflow-y to auto, which breaks the body
            scroll and the sticky breadcrumb. `clip` stops the page sliding
            sideways under the fixed sidebar while leaving both intact — wide
            content scrolls in its own container instead. */}
        <SidebarProvider className="ph-no-capture overflow-x-clip">
          <AdminSidebar />
          <SidebarInset>
            <SuspenseAndErrorBoundary fallback={<PageSkeleton />}>
              <Outlet />
            </SuspenseAndErrorBoundary>
          </SidebarInset>
        </SidebarProvider>
      </SuspenseAndErrorBoundary>
      <GlobalSearchBar />
    </HubSpotProvider>
  );
};

export const Route = createFileRoute("/_authed/$companySlug/admin")({
  component: AdminLayout,
});
